import { createFileRoute } from "@tanstack/react-router";
import VariantD from "@/components/funnel/variants/VariantD";
import { BRAND_META_DESCRIPTION, BRAND_NAME } from "@/components/inflow/brand";

export const Route = createFileRoute("/lp-d")({
  head: () => ({
    meta: [
      { title: `${BRAND_NAME} — Variant D` },
      { name: "description", content: BRAND_META_DESCRIPTION },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: `${BRAND_NAME} — Variant D` },
      { property: "og:description", content: BRAND_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: VariantD,
});
